import React from 'react';
import { useSelector } from 'react-redux';
import { selectExtraRewardsPage, selectSiteUrl } from 'core/selectors/app';
import { convertDateTimeToETTimezone } from 'core/utils/helpers/date';
import { addCommas } from 'core/utils/helpers/numbers';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import { useModal } from 'core/modules/Modal/ModalProvider';
import orgConfig from 'org/configs/org.config';
import config from '../configs';

function BonusHomeBannerItem({ item, instanceType }) {
  const { openModal } = useModal();
  const { earnType } = orgConfig;
  const { getClientName, dateFormat } = config;
  const {
    endDate, offers, id, isAutomaticPlacement, name,
  } = item;
  const { minSpendToQualify, maxRewardAvailable } = offers[0];

  const endDateETTimeZone = convertDateTimeToETTimezone(endDate);
  const formattedFullEndDate = endDateETTimeZone.format(dateFormat);

  const clientName = getClientName();

  const siteUrl = useSelector(selectSiteUrl);
  const extraRewardsPage = useSelector(selectExtraRewardsPage);

  const moreText = instanceType === 'bottomMhpBanner' ? '+ ' : ' or more ';
  const shouldShowAsterix = instanceType === 'bottomVhpBanner' || instanceType === 'topVhpBanner';

  const showTerms = () => {
    const { terms } = item.offers[0];

    openModal({
      name: 'mt_termsAndConditions',
      params: { terms },
    });
  };

  return (
    <div className="mn_item">
      <h2 key={id}>
        Earn {addCommas(maxRewardAvailable)} {clientName} bonus {earnType} when
        you spend {addCommas(minSpendToQualify)}{moreText} by {formattedFullEndDate}
        <span className="mn_dot">.</span>{shouldShowAsterix && '*'}
      </h2>
      <div className="mn_bottomWrap">
        {isAutomaticPlacement
          ? <a href={`${siteUrl}${extraRewardsPage}`} data-id={id}>Shop the {name}</a>
          : <button className="mn_termsButton" onClick={showTerms}>View bonus terms and conditions</button>
        }
      </div>
    </div>
  );
}

export default (props) =>
  <ComponentErrorBoundary><BonusHomeBannerItem {...props} /></ComponentErrorBoundary>;
